import { BANNER_POSITION, bannerPositions } from '../apps/BannersApp/constants/banners';

const SKIN_BANNER_MIN_WIDTH = 1200;

const TOP_BANNER_CONTAINER_ID = bannerPositions[BANNER_POSITION.STATIC.TOP].containerId;

// Extra horizontal spacing (px) between a skin side panel and the page content
const SKIN_PANEL_SIDE_MARGIN = 16;

export function positionSkinBannerPanel(container: HTMLElement, wrapper: HTMLElement): void {
  if (!container || !wrapper) return;

  const iframeContainer =
    container.querySelector<HTMLElement>('[id^="google_ads_iframe_"]') ||
    container.querySelector<HTMLElement>('[id^="div-gpt-ad-"]');
  if (!iframeContainer) return;

  const iframe = iframeContainer.querySelector('iframe');
  if (!iframe) return;

  const iframeWidth = iframe.offsetWidth || parseInt(iframe.getAttribute('width') || '0', 10);
  const iframeHeight = iframe.offsetHeight || parseInt(iframe.getAttribute('height') || '0', 10);

  if (iframeWidth === 0 || iframeHeight === 0) return;

  if (iframeWidth >= SKIN_BANNER_MIN_WIDTH) {
    // Align the side panel's top edge with the top banner so the skin appears connected
    const topBannerEl = document.getElementById(TOP_BANNER_CONTAINER_ID);
    if (topBannerEl) {
      const topBannerTop = topBannerEl.getBoundingClientRect().top + window.scrollY;
      const wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
      const topGap = wrapperTop - topBannerTop;
      if (topGap > 0) {
        wrapper.style.marginTop = `-${topGap}px`;
      }
    }

    // Add extra horizontal spacing between the side panel and the page content
    const isLeftPanel = container.id.includes('left');
    if (isLeftPanel) {
      wrapper.style.marginRight = `${SKIN_PANEL_SIDE_MARGIN}px`;
    } else {
      wrapper.style.marginLeft = `${SKIN_PANEL_SIDE_MARGIN}px`;
    }
  } else {
    wrapper.style.marginTop = '';
    wrapper.style.marginRight = '';
    wrapper.style.marginLeft = '';
  }
}
